"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentInfosShipmentListTypeEnum = exports.ShipmentInfosShipmentListToJSON = exports.ShipmentInfosShipmentListFromJSONTyped = exports.ShipmentInfosShipmentListFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentInfosShipmentListFromJSON(json) {
    return ShipmentInfosShipmentListFromJSONTyped(json, false);
}
exports.ShipmentInfosShipmentListFromJSON = ShipmentInfosShipmentListFromJSON;
function ShipmentInfosShipmentListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'state': json['state'],
        'product': (0, _1.ShipmentProductFromJSON)(json['product']),
        'packages': !(0, runtime_1.exists)(json, 'packages') ? undefined : (json['packages'].map(_1.ShipmentInfosPackagesFromJSON)),
        'orderDetails': !(0, runtime_1.exists)(json, 'orderDetails') ? undefined : (0, _1.ShipmentInfosOrderDetailsFromJSON)(json['orderDetails']),
    };
}
exports.ShipmentInfosShipmentListFromJSONTyped = ShipmentInfosShipmentListFromJSONTyped;
function ShipmentInfosShipmentListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'state': value.state,
        'product': (0, _1.ShipmentProductToJSON)(value.product),
        'packages': value.packages === undefined ? undefined : (value.packages.map(_1.ShipmentInfosPackagesToJSON)),
        'orderDetails': (0, _1.ShipmentInfosOrderDetailsToJSON)(value.orderDetails),
    };
}
exports.ShipmentInfosShipmentListToJSON = ShipmentInfosShipmentListToJSON;
/**
* @export
* @enum {string}
*/
var ShipmentInfosShipmentListTypeEnum;
(function (ShipmentInfosShipmentListTypeEnum) {
    ShipmentInfosShipmentListTypeEnum["All"] = "all";
    ShipmentInfosShipmentListTypeEnum["Ordered"] = "ordered";
    ShipmentInfosShipmentListTypeEnum["ShipmentPrepared"] = "shipment_prepared";
    ShipmentInfosShipmentListTypeEnum["Sent"] = "sent";
    ShipmentInfosShipmentListTypeEnum["InDelivery"] = "in_delivery";
    ShipmentInfosShipmentListTypeEnum["Delivered"] = "delivered";
    ShipmentInfosShipmentListTypeEnum["Returned"] = "returned";
    ShipmentInfosShipmentListTypeEnum["ReturnlabelCreated"] = "returnlabel_created";
    ShipmentInfosShipmentListTypeEnum["Canceled"] = "canceled";
    ShipmentInfosShipmentListTypeEnum["AwaitingDownpayment"] = "awaiting_downpayment";
    ShipmentInfosShipmentListTypeEnum["ReturnShipment"] = "return_shipment";
})(ShipmentInfosShipmentListTypeEnum = exports.ShipmentInfosShipmentListTypeEnum || (exports.ShipmentInfosShipmentListTypeEnum = {}));
//# sourceMappingURL=ShipmentInfosShipmentList.js.map